import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function FinalClose() {
  return <Section background="cream" className="text-center pb-32" data-id="element-13">
      <div className="max-w-xl mx-auto" data-id="element-14">
        <h2 className="text-3xl font-bold text-[#2C2C2C] mb-6" data-id="element-15">
          No necesitas otra promesa.
        </h2>

        <p className="text-xl text-[#5A5A5A] mb-8" data-id="element-16">
          Necesitas volver a sentir que tú manejas el volante.
          <br data-id="element-17" />
          <br data-id="element-18" />
          Empieza con 10 minutos mañana.
          <br data-id="element-19" />Y repite.
        </p>

        <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-20">
          Descargar Menopausia Sin Caos
        </Button>
      </div>
    </Section>;
}